import { Component } from '@angular/core';
import {
  AgActionIconButtonComponent
} from "@shared/components/grid/ag-cells/common/ag-action-icon-button/ag-action-icon-button.component";
import { HasRoleDirective } from '@shared/directives/has-role.directive';
import { ICellRendererAngularComp } from "ag-grid-angular";
import { ICellRendererParams } from 'ag-grid-community';
import { UserInvitationRecord } from '@models/organisations/user-invitation-record';
import { UserRecord } from "@models/organisations/user-record";

type ActionEvent = (data: UserRecord | UserInvitationRecord | undefined) => void;

type CellRendererParams = ICellRendererParams<UserRecord | UserInvitationRecord> & {
  edit: ActionEvent,
  delete: ActionEvent,
  resetPassword: ActionEvent,
  resetMFA: ActionEvent,
};

@Component({
  selector: 'app-account-management-grid-actions',
  standalone: true,
  imports: [
    AgActionIconButtonComponent,
    HasRoleDirective
  ],
  templateUrl: './ag-users-and-permissions-actions.component.html',
  styleUrl: './ag-users-and-permissions-actions.component.scss'
})
export class AgUsersAndPermissionsActionsComponent implements ICellRendererAngularComp {
  protected params!: CellRendererParams;
  isUserRecord!: boolean;

  agInit(params: CellRendererParams): void {
    this.params = params;
    this.isUserRecord = 'externalId' in params.data!;
  }

  refresh(params: CellRendererParams): boolean {
    this.params = params;
    return true;
  }

  onEdit(): void {
    this.params.edit(this.params.data);
  }

  onResetMFA(): void {
    this.params.resetMFA(this.params.data);
  }

  onResetPassword(): void {
    this.params.resetPassword(this.params.data);
  }

  onDelete(): void {
    this.params.delete(this.params.data);
  }
}
